exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".popover-content .size-info{border:1px solid #f79919;padding:0 2px;width:20px;display:inline-block;text-align:center;line-height:1rem;color:#f79919}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2577c1d0!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popover/CartPhotoSizeChangePopover.vue
// module id = 551
// module chunks = 0